function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["tokens", "colors"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as BaseThemeProvider, useFela } from 'react-fela';
import getThemeColors from './getThemeColors.js';
import getVariables from './getVariables.js';
import El from '../components/el';
import core from '../themes/core.js';
import dark from '../themes/dark.js';
import light from '../themes/light.js';
var themes = {
  light: light,
  dark: dark
};
export default function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    children = _ref.children;
  var _useFela = useFela(),
    renderer = _useFela.renderer;
  var _themes$theme = themes[theme],
    tokens = _themes$theme.tokens,
    colors = _themes$theme.colors,
    rest = _objectWithoutProperties(_themes$theme, _excluded);
  var appliedTheme = _objectSpread(_objectSpread(_objectSpread({}, core), rest), {}, {
    colors: _objectSpread(_objectSpread({}, getThemeColors(core.colors)), getThemeColors(colors)),
    tokens: _objectSpread(_objectSpread({}, core.tokens), getThemeColors(tokens, 't-'))
  });
  if (renderer) {
    renderer.renderStatic(_objectSpread(_objectSpread(_objectSpread({}, getVariables(core.colors)), getVariables(colors)), getVariables(tokens, 't-')), '.' + theme + '-theme');
  }
  return /*#__PURE__*/React.createElement(BaseThemeProvider, {
    theme: appliedTheme
  }, /*#__PURE__*/React.createElement(El, {
    className: theme + '-theme',
    extend: {
      display: 'contents'
    }
  }, children));
}
ThemeProvider.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark'])
};